import * as React from "react";
function SvgFavorite(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M11.1999 18.7724L11.1988 18.7714C8.86621 16.6562 6.99101 14.954 5.68991 13.3633C4.39743 11.7831 3.75 10.4046 3.75 8.95C3.75 6.59221 5.59221 4.75 7.95 4.75C9.28891 4.75 10.5857 5.37695 11.429 6.36725L12 7.0378L12.571 6.36725C13.4143 5.37695 14.7111 4.75 16.05 4.75C18.4078 4.75 20.25 6.59221 20.25 8.95C20.25 10.4046 19.6026 11.7831 18.3099 13.3646C17.0088 14.9564 15.1338 16.6607 12.8014 18.7802C12.8011 18.7805 12.8009 18.7807 12.8006 18.7809L12.0019 19.5025L11.1999 18.7724Z" strokeWidth={1.5} /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "src/assets/icons/favorite.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/favorite_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/favorite_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/favorite_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/favorite_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/favorite_4x.svg"
};
export { ForwardRef as ReactComponent };